// Spanish
export const es = {
  'app.name':           'Kardolive',
  'app.tagline':        'Portal de cliente',
  'app.signOut':        'Cerrar sesión',

  'login.email':        'Correo electrónico',
  'login.password':     'Contraseña',
  'login.signIn':       'Iniciar sesión',
  'login.signingIn':    'Iniciando sesión…',
  'login.failed':       'Error al iniciar sesión',
  'login.newAccount':   '¿Nuevo en Kardolive?',
  'login.createAccount':'Crear una cuenta gratis →',

  'nav.workspace':      'Espacio de trabajo',
  'nav.templates':      'Plantillas',
  'nav.live':           'En vivo',
  'nav.rooms':          'Salas y chat',
  'nav.content':        'Contenido',
  'nav.developer':      'Desarrollador',
  'nav.account':        'Cuenta',

  'nav.overview':       'Resumen',
  'nav.projects':       'Proyectos',
  'nav.chat':           'Consola de chat',
  'nav.sessions':       'Sesiones',
  'nav.streams':        'Transmisiones en vivo',
  'nav.studio':         'Estudio',
  'nav.recordings':     'Grabaciones',
  'nav.apiKeys':        'Claves API',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Probador de webhooks',
  'nav.networkTest':    'Prueba de red',
  'nav.embed':          'Widgets embebidos',
  'nav.sdk':            'SDKs y documentación',
  'nav.docs':           'Docs para desarrolladores',
  'nav.analytics':      'Analítica',
  'nav.settings':       'Configuración',

  'overview.welcome':       'Bienvenido de nuevo, {name}',
  'overview.plan':          '{tenant} · plan {plan}',
  'overview.newStream':     'Nueva transmisión',
  'overview.kpi.live':           'En vivo ahora',
  'overview.kpi.live.broadcasting': 'transmisiones en directo',
  'overview.kpi.live.nothing':    'nada en vivo',
  'overview.kpi.total':           'Transmisiones totales',
  'overview.kpi.total.sub':       'todas las épocas',
  'overview.kpi.sessions':        'Sesiones · 30 días',
  'overview.kpi.sessions.sub':    'eventos de publicación',
  'overview.kpi.recordings':      'Grabaciones',
  'overview.kpi.recordings.sub':  'listas para reproducir',
  'overview.recentStreams':       'Transmisiones recientes',
  'overview.recentSessions':      'Sesiones recientes',
  'overview.viewAll':             'Ver todas →',
  'overview.empty.title':         'Aún no hay transmisiones',
  'overview.empty.body':          'Crea tu primera transmisión para comenzar a emitir.',
  'overview.empty.action':        'Crear transmisión',
  'overview.noSessions':          'Aún no hay sesiones',

  'status.live':        'EN VIVO',
  'status.idle':        'INACTIVO',
  'status.ended':       'FINALIZADO',
  'status.archived':    'ARCHIVADO',

  'common.save':        'Guardar',
  'common.cancel':      'Cancelar',
  'common.delete':      'Eliminar',
  'common.edit':        'Editar',
  'common.create':      'Crear',
  'common.confirm':     'Confirmar',
  'common.loading':     'Cargando…',
  'common.error':       'Error',
  'common.retry':       'Reintentar',

  // Dashboard navigation and account controls.
  "nav.skipContent": "Ir al contenido de la página",
  "nav.streamTemplates": "Plantillas de transmisión",
  "nav.boards": "Pizarras interactivas",
  "nav.menu": "Abrir navegación",
  "nav.closeMenu": "Cerrar navegación",
  "nav.scenarios": "Escenarios",
  "nav.premieres": "Estrenos",
  "nav.clips": "Clips",
  "dashboard.account": "Cuenta",
  "dashboard.language": "Idioma",
  "dashboard.appearance": "Apariencia",
  "nav.allStreams": "Todas las transmisiones",
  "nav.destinations": "Destinos",
  "nav.ecommerce": "Comercio electrónico",
  "nav.products": "Productos",
  "nav.services": "Servicios",
  "nav.collections": "Colecciones",
  "nav.orders": "Pedidos",
  "nav.commerceSettings": "Configuración comercial",
  "nav.engagement": "Interacción",
  "theme.light": "Cambiar al modo claro",
  "theme.dark": "Cambiar al modo oscuro",
  "role.owner": "Propietario",
  "role.admin": "Administrador",
  "role.member": "Miembro",
  "role.viewer": "Observador",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "Activos",
  "streams.archived": "Archivados",
  "streams.monitor": "Monitor de señales",
  "streams.create": "Crear transmisión en vivo",
  "streams.list": "Lista",
  "streams.grid": "Cuadrícula",
  "streams.view": "Vista de transmisiones",
  "streams.searchLabel": "Buscar eventos",
  "streams.searchHint": "Buscar por nombre",
  "streams.solutionFilter": "Filtrar eventos por tipo",
  "streams.statusFilter": "Filtrar eventos por estado",
  "streams.dateFilter": "Filtrar eventos por fecha de creación",
  "streams.allSolutions": "Todos los tipos",
  "streams.custom": "Configuración existente o personalizada",
  "streams.allStatuses": "Todos los estados",
  "streams.anyTime": "Cualquier fecha de creación",
  "streams.last7": "Creados en los últimos 7 días",
  "streams.last30": "Creados en los últimos 30 días",
  "streams.count": "Se muestran {shown} de {total} eventos",
  "streams.noMatch": "Ningún evento coincide con los filtros.",
  "streams.clearFilters": "Borrar filtros",
  "streams.refreshFailed": "No se pudo actualizar la lista",
  "streams.loadFailed": "No se pudieron cargar las transmisiones",
  "streams.stale": "Se muestra la última lista cargada. Los estados pueden haber cambiado.",
  "streams.connectionHint": "Comprueba la conexión y vuelve a cargar la lista.",
  "streams.retrying": "Reintentando…",
  "streams.retry": "Reintentar",
  "streams.restoreFailed": "No se pudo restaurar la transmisión",
  "streams.restoreHint": "Comprueba la conexión y actualiza la lista para confirmar el estado antes de reintentar.",
  "streams.unused": "Transmisiones sin usar: {count}",
  "streams.unusedHint": "No tienen emisiones ni repeticiones. Archívalas para ordenar la lista; no se elimina nada.",
  "streams.reviewArchive": "Revisar y archivar",
  "streams.loading": "Cargando transmisiones…",
  "streams.archiveEmpty": "No hay transmisiones archivadas. Las transmisiones archivadas y sus repeticiones se conservan aquí hasta que las restaures.",
  "streams.restore": "Restaurar",
  "streams.firstTitle": "Crea tu primera transmisión",
  "streams.firstBody": "Elige una configuración para ventas, clases o servicios, o empieza desde cero. Transmite desde el navegador, el teléfono u OBS.",
  "streams.blank": "Transmisión en blanco",
  "streams.broadcasts": "Emisiones: {count}",
  "streams.replays": "Repeticiones: {count}",
  "streams.sessions": "Sesiones: {count}",
  "streams.recordings": "Grabaciones: {count}",
  "streams.mode.BROADCAST": "Difusión",
  "streams.mode.LOW_LATENCY": "Baja latencia",
  "streams.mode.REALTIME": "Tiempo real",
  "streams.key": "Clave",
  "streams.archiveTitle": "Archivar transmisiones sin usar",
  "streams.archiveHint": "Estas transmisiones nunca se han emitido. Puedes restaurarlas cuando quieras desde Archivados.",
  "streams.archiveFailed": "No se pudieron archivar {count} transmisiones; puede que hayan empezado a emitir. Las demás se archivaron.",
  "streams.archiving": "Archivando…",
  "streams.archiveCount": "Archivar {count}",
  "streamType.webinar": "Webinarios y lanzamientos empresariales",
  "streamType.classroom": "Clases y tutorías",
  "streamType.training": "Formación corporativa",
  "streamType.conference": "Conferencias y exposiciones",
  "streamType.shopping": "Compras en directo",
  "streamType.auction": "Subastas en directo",
  "streamType.consultation": "Consultas privadas",
  "streamType.creator": "Directos de creadores y comunidades",
  "streamType.audio": "Salas de audio y pódcast",
  "streamType.sports": "Deportes y deportes electrónicos",
  "streamType.performance": "Conciertos y espectáculos",
  "streamType.community": "Culto y recaudación de fondos",
  "streamType.tour": "Visitas y demostraciones",
  "streamType.fitness": "Fitness y talleres",
  "streamType.public-meeting": "Noticias y reuniones públicas",
  "streamType.continuous": "Canales continuos y cámaras",
  "streams.close": "Cerrar",
};
